import React from 'react';
import { useSelector } from 'react-redux';

import { Box, Divider } from '@mui/material';
import LoanInfoCards from '@sharedCR/loanSummary/LoanInfoCards';
import { WithLoadingPropTypes } from 'hocs/withLoading';

import useModifiedFieldPendingChangeAuthors from 'hooks/useModifiedFieldPendingChangeAuthors';
import useTruncatedGeneral from 'hooks/useTruncatedGeneral';

import { selectLoanSummaryInfo } from 'store/loanApplications/selectors';

import BorrowerInformation from './BorrowerInformation';
import { dividerStyles, loanInfoCardStyles, wrapperStyles } from './LoanSummaryInformation.styles';

const LoanSummaryInformation = ({ isLoading }) => {
  const summary = useSelector(selectLoanSummaryInfo);
  const getModifiedFieldAuthors = useModifiedFieldPendingChangeAuthors();

  const [onMouseOver, onResetTooltipState, TruncatedProvider] = useTruncatedGeneral();

  return (
    <Box sx={wrapperStyles} onMouseLeave={onResetTooltipState} onMouseOver={onMouseOver}>
      <TruncatedProvider />

      <BorrowerInformation isLoading={isLoading} summary={summary} />

      <Divider sx={dividerStyles} />

      <LoanInfoCards
        customInfoCardStyles={loanInfoCardStyles}
        getPendingChangeAuthors={getModifiedFieldAuthors}
        isLoading={isLoading}
        summary={summary}
      />
    </Box>
  );
};

LoanSummaryInformation.propTypes = {
  ...WithLoadingPropTypes,
};

export default LoanSummaryInformation;
